import { lazy, Suspense } from 'react';

export function loadWangEditor() {
  return import(
    /* webpackChunkName: "@wangeditor" */
    /* webpackPrefetch: true */
    './WangEditor'
  );
}

const LazyEditor = lazy(() => loadWangEditor().then((module) => ({ default: module.Editor })));
const LazyToolbar = lazy(() => loadWangEditor().then((module) => ({ default: module.Toolbar })));

// Editor 和 Toolbar 名字太普遍了，包成 WangEditor 在 index.js 里进行导出
const AsyncWangEditor = {
  Editor(props) {
    return (
      <Suspense fallback={null}>
        <LazyEditor {...props} />
      </Suspense>
    );
  },
  Toolbar(props) {
    return (
      <Suspense fallback={null}>
        <LazyToolbar {...props} />
      </Suspense>
    );
  },
};

export default AsyncWangEditor;
